import { compose } from 'recompose';
import Channel from './Channel';
import { query, mutation } from './API';
import withRequestTracker from '../../../utils/composition/withRequestTracker';
import { TOGGLE_STATE } from '../../common/GqlAPI';

const composedChannel = compose(TOGGLE_STATE, withRequestTracker({ query, mutation }))(Channel);

export default composedChannel;
